export enum ARROW_DIRECTION {
  left = 'left',
  right = 'right',
}

export interface ArrowInterface {
  direction: ARROW_DIRECTION;
  disabled: boolean;
  extraClass?: string;
  onClick: () => void;
}
